import { Empty } from "antd";
import SelectAllCard from "../selectAll";
import SalaryUploadCard from "../salaryUpload";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import PaginationComponent from "../../paginationComponet";

export default function SalaryUploadGrid({
  dataSource = [],
  handleSelectAll,
  handleMultiApproveOrReject,
  selectAllChecked,
  handleMultiDelete,
  handleCheckBoxChange,
  handleApproveOrReject,
  handleDelete,
  handleSingleRcordDownload,
}) {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  useEffect(() => {
    setData(dataSource.slice(0, 10));
  }, [dataSource]);

  const handlePageChange = (currentPage, slicedData) => {
    setData(slicedData);
  };
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty
          description={t("common.no_records_found", {
            defaultValue: "No Records Found",
          })}
        />
      ) : (
        <div className="ft-table">
          <table className="table" style={{ cursor: "pointer" }}>
            <thead style={{ backgroundColor: "#F1F1F1" }}>
              <tr>
                <th>
                  <SelectAllCard
                    record={dataSource}
                    handleSelectAll={handleSelectAll}
                    handleMultiApproveOrReject={handleMultiApproveOrReject}
                    selectAllChecked={selectAllChecked}
                    handleMultiDelete={handleMultiDelete}
                  />
                </th>
                <th>
                  {t("pages.pending_approval.file_name", {
                    defaultValue: "File Name",
                  })}
                </th>
                <th>
                  {t("pages.my_accounts.common_my_accounts.value_date", {
                    defaultValue: "Value Date",
                  })}
                </th>
                <th>
                  {t("pages.gepeg.source_account", {
                    defaultValue: "Source Account",
                  })}
                </th>
                <th>
                  {t("pages.upload.process_name", {
                    defaultValue: "Process Name",
                  })}
                </th>
                <th>
                  {t("pages.pending_approval.Initiated_Date", {
                    defaultValue: "Initiated Date",
                  })}
                </th>
              </tr>
            </thead>

            <tbody>
              {data.map((option, index) => (
                <SalaryUploadCard
                  record={option}
                  handleCheckBoxChange={handleCheckBoxChange}
                  handleApproveOrReject={handleApproveOrReject}
                  handleDelete={handleDelete}
                  handleSingleRcordDownload={handleSingleRcordDownload}
                />
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="8"> 
                  {dataSource.length > 10 && (
                    <PaginationComponent
                      dataSource={dataSource}
                      pageSize={10}
                      onPageChange={handlePageChange}
                    />
                   )}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </>
  );
}
